import Link from 'next/link';
import type { LucideIcon } from 'lucide-react';

/** The frosted circle centered above Search: contextual Plus or a page's
 * own primary action. */
export const DOCK_ACTION_CLASS =
  'mobile-search-island navigation-glass pointer-events-auto inline-flex items-center justify-center rounded-full text-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-text';

/** A page's primary action in the contextual Plus slot, e.g. recipe Edit.
 * Register it through `PageHeader`'s `mobileDockAction`. */
export function DockActionLink({
  href,
  label,
  icon: Icon
}: {
  href: string;
  label: string;
  icon: LucideIcon;
}) {
  return (
    <Link href={href} aria-label={label} className={DOCK_ACTION_CLASS}>
      <Icon className="size-6" aria-hidden />
    </Link>
  );
}
